import { forwardRef } from 'react'
import Styles from '../MobileHome.module.scss'
import cx from 'classnames'
import { useObjectRef } from 'utils/useObjectRef'
import { useRootStore } from 'stores/RootStore'
import useButtonWithScrollCancel from 'hooks/useButtonWithScrollCancel'

export type ContentCardProps = {
  className?: string
  title: string
  description?: string
  badge?: React.ReactElement
  imgSrc: string
  imgScale?: number
  imgBottom?: string | number
  imgRight?: string | number
  onPress?: () => void
  textWidth?: string | number
  fontSize?: string | number
  bottomLeftIcon?: React.ReactNode
}

export const ContentCard = forwardRef<HTMLDivElement, ContentCardProps>((props, fRef) => {
  const {
    title,
    description,
    badge,
    className,
    imgSrc,
    imgScale,
    imgBottom,
    imgRight,
    onPress,
    textWidth,
    bottomLeftIcon,
  } = props
  const { drawersStore } = useRootStore()
  const handlePress = onPress ? onPress : () => drawersStore.closeAllDrawers()

  const ref = useObjectRef(fRef)
  const { buttonProps, isPressed } = useButtonWithScrollCancel({ onPress: handlePress, elementType: 'div' }, ref)

  return (
    <div
      {...buttonProps}
      ref={ref}
      className={cx(Styles.contentCard, className, {
        [Styles.pressed]: isPressed,
      })}
    >
      {badge && <div className={Styles.badge}>{badge}</div>}
      <label style={{ maxWidth: textWidth }}>{title}</label>
      {description && (
        <span style={{ maxWidth: textWidth }} className={Styles.description}>
          {description}
        </span>
      )}
      {bottomLeftIcon && <div className={Styles.bottomLeftIcon}>{bottomLeftIcon}</div>}
      <img
        style={{
          transform: `scale(${imgScale})`,
          ...(imgBottom !== undefined && { bottom: imgBottom }),
          ...(imgRight !== undefined && { right: imgRight }),
        }}
        src={imgSrc}
        alt=""
      />
    </div>
  )
})
